import { render, staticRenderFns } from "./ConversationToolbar.vue?vue&type=template&id=5bdb3e4a&scoped=true"
import script from "./ConversationToolbar.vue?vue&type=script&lang=js"
export * from "./ConversationToolbar.vue?vue&type=script&lang=js"
import style0 from "./ConversationToolbar.vue?vue&type=style&index=0&id=5bdb3e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb3e4a",
  null
  
)

export default component.exports